module.exports = __webpack_public_path__ + "static/media/LOGO.c419bc40.svg";